const dateFormatter = (date) => {
    const deliveryDate = typeof date === 'string' ? new Date(date) : date;
    const month = deliveryDate.toLocaleDateString('es-MX', { month: 'long', timeZone: 'UTC' });
    const year = deliveryDate.getUTCFullYear();
    return `${month.charAt(0).toUpperCase() + month.slice(1)} de ${year}`;
};
export default dateFormatter;
